/* AULBERY — Hero V2 (sections/as-hero-v2.liquid)
   Rotating-word engine, moved 1:1 from the section's inline script.
   Per-instance values are read from data-* attributes on [data-as-hero-v2].
   Adds shopify:section:unload cleanup (interval, timeouts, window/document
   listeners); visible behaviour is unchanged. */
(function () {
  function initHero(root) {
    if (!root || root.dataset.ashInit === '1') return;
    root.dataset.ashInit = '1';

    var destroyed = false;
    var cleanups = [];
    root._ashCleanup = function () {
      destroyed = true;
      cleanups.forEach(function (fn) { fn(); });
      cleanups = [];
    };

    // Lock the hero's height in pixels. In svh the box re-computes when
    // the phone's address bar collapses, which moves anything anchored to
    // its bottom edge — the copy — while the image, being inset: 0 cover,
    // stays put. Measured once here, re-measured only on a real width
    // change further down.
    function lockHeight() {
      root.style.height = '';
      var h = root.getBoundingClientRect().height;
      if (h) root.style.height = Math.round(h) + 'px';
    }
    lockHeight();

    var roller = root.querySelector('.ash-roller');
    var inner = root.querySelector('.ash-roller-inner');
    var words = Array.prototype.slice.call(root.querySelectorAll('[data-ash-word]'));
    if (!roller || !inner || words.length < 2) return;

    var style = root.dataset.changeStyle || 'roll';
    var holdMs = parseInt(root.dataset.holdMs, 10) || 1800;
    var moveMs = parseInt(root.dataset.moveMs, 10) || 600;
    var ease = root.dataset.moveEase || 'cubic-bezier(0.22, 1, 0.36, 1)';
    var resizeMs = parseInt(root.dataset.resizeMs, 10);
    if (isNaN(resizeMs)) resizeMs = 150;
    var lockWidth = root.dataset.lockWidth !== '0';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var i = 0;
    var timer = null;

    // Measure the rendered word rather than assuming font-size: a line box
    // at line-height 1 clips descenders, and the right number depends on
    // the font actually in use.
    function measure() {
      var h = 0;
      var w = 0;
      words.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > h) h = r.height;
        if (r.width > w) w = r.width;
      });
      if (!h) return;
      roller.style.height = Math.ceil(h) + 'px';
      if (lockWidth) {
        // hold the widest word's width so nothing after it shifts
        roller.style.width = Math.ceil(w) + 'px';
      }
      if (style !== 'fade') {
        words.forEach(function (el) { el.style.height = Math.ceil(h) + 'px'; });
      }
      return h;
    }

    function show(n) {
      if (style === 'fade') {
        words.forEach(function (el, k) {
          el.style.transition = 'opacity ' + moveMs + 'ms ' + ease + ', transform ' + moveMs + 'ms ' + ease;
          el.classList.toggle('is-on', k === n);
        });
        return;
      }
      var h = roller.getBoundingClientRect().height;
      inner.style.transition = 'transform ' + moveMs + 'ms ' + ease;
      inner.style.transform = 'translate3d(0, ' + (-n * h) + 'px, 0)';
    }

    function step() {
      i = (i + 1) % words.length;
      if (i === 0 && style !== 'fade') {
        // back to the top: jump with no transition, then carry on. The
        // frame is identical, so there is nothing to see.
        inner.style.transition = 'none';
        inner.style.transform = 'translate3d(0, 0, 0)';
        // force the style to apply before transitions go back on
        void inner.offsetHeight;
        return;
      }
      show(i);
    }

    function start() {
      stop();
      if (reduce.matches || destroyed) return;
      timer = window.setInterval(step, holdMs + moveMs);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    cleanups.push(stop);

    measure();
    show(0);

    // re-measure once the webfont has swapped in, and on resize
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (!destroyed) settle(); });
    }
    // Only a width change is a real resize. On a phone the address bar
    // collapsing and expanding fires resize on every scroll with the same
    // width, and re-measuring there is what made the headline jump.
    var lastWidth = window.innerWidth;
    var rt;
    function onResize() {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      window.clearTimeout(rt);
      rt = window.setTimeout(function () { settle(); }, resizeMs);
    }
    window.addEventListener('resize', onResize);
    cleanups.push(function () {
      window.removeEventListener('resize', onResize);
      window.clearTimeout(rt);
    });

    // re-place the word with no transition, so a genuine resize lands
    // instead of sliding across
    function settle() {
      lockHeight();
      measure();
      if (style === 'fade') {
        words.forEach(function (el) { el.style.transition = 'none'; });
      } else {
        inner.style.transition = 'none';
      }
      show(i);
      void inner.offsetHeight;
    }

    // never come back from a background tab mid-change
    function onVisibility() {
      if (document.hidden) stop();
      else start();
    }
    document.addEventListener('visibilitychange', onVisibility);
    cleanups.push(function () { document.removeEventListener('visibilitychange', onVisibility); });

    if (reduce.addEventListener) {
      var onReduce = function () {
        if (reduce.matches) { stop(); i = 0; show(0); } else { start(); }
      };
      reduce.addEventListener('change', onReduce);
      cleanups.push(function () { reduce.removeEventListener('change', onReduce); });
    }

    start();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-as-hero-v2]');
    Array.prototype.forEach.call(roots, initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target ? e.target.querySelectorAll('[data-as-hero-v2]') : [];
    Array.prototype.forEach.call(roots, function (root) {
      if (root._ashCleanup) root._ashCleanup();
    });
  });
})();

